import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ba00dc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ss-principais-acoes" }
const _hoisted_5 = { class: "ant-btn-group ss-grupo-recursos" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Gerar Relatório", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "ss-tela-conteudo" }
const _hoisted_9 = { class: "ss-card ss-card-space" }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESAS")
], -1))
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_15 = {
  key: 0,
  class: "ant ant-col-xs-1 ant-col-xl-1"
}
const _hoisted_16 = {
  key: 1,
  class: "ant ant-col-xs-1 ant-col-xl-1"
}
const _hoisted_17 = {
  key: 2,
  class: "ant ant-col-xs-1 ant-col-xl-1"
}
const _hoisted_18 = {
  key: 3,
  class: "ant ant-col-xs-1 ant-col-xl-1"
}
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_21 = {
  key: 0,
  class: "ant-col ant-col-xs-2 ant-col-xl-2"
}
const _hoisted_22 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_23 = { class: "ant-row" }
const _hoisted_24 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_25 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_26 = {
  class: "ss-card ss-card-space ss-alinhar-texto-esquerda",
  style: {"min-height":"40%"}
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Resultado", -1))
const _hoisted_28 = {
  class: "ant-row",
  style: {"text-align":"center"}
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-7 ant-col-xl-7",
  style: {"margin-left":"14px"}
}, null, -1))
const _hoisted_30 = {
  class: "ant-col ant-col-xs-1 ant-col-xl-1",
  style: {"text-align":"right","margin-top":"3px"}
}
const _hoisted_31 = {
  class: "ant-col ss-coluna-periodo",
  style: {"text-align":"left","margin-top":"3px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_selecionar_estrutura_d_r_e = _resolveComponent("selecionar-estrutura-d-r-e")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_sazonalidade = _resolveComponent("selecionar-sazonalidade")!
  const _component_selecionar_generico = _resolveComponent("selecionar-generico")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_selecionar_centro_custo = _resolveComponent("selecionar-centro-custo")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_grupo_resultado_d_r_e = _resolveComponent("grupo-resultado-d-r-e")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_estrutura_d_r_e_modal = _resolveComponent("estrutura-d-r-e-modal")!
  const _component_grupo_estrutura_d_r_e_modal = _resolveComponent("grupo-estrutura-d-r-e-modal")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_titulo_padrao, {
            identificadorRecurso: _ctx.telaBase.identificadorRecurso,
            tituloRecurso: _ctx.telaBase.titulo,
            exibirAtalhosTela: true,
            exibirHistoricoTela: false,
            empresasSelecionadas: [_ctx.state.codigoEmpresa]
          }, {
            BotoesAcoes: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-btn-recursos",
                    title: "Imprimir",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF)))
                  }, [
                    _createVNode(_component_icone, { nome: "imprimir" })
                  ]),
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-btn-recursos",
                    title: "Exportar Excel",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Excel)))
                  }, [
                    _createVNode(_component_icone, { nome: "excel" })
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "ant-btn ant-btn-primary ss-btn-tela",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.obterResultado(0)))
                  }, _hoisted_7)
                ])
              ])
            ]),
            _: 1
          }, 8, ["identificadorRecurso", "tituloRecurso", "empresasSelecionadas"]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_a_form, { layout: "vertical" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_a_select, {
                        value: _ctx.state.codigoEmpresa,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.codigoEmpresa) = $event)),
                        options: _ctx.telaBase.empresasDisponiveis,
                        style: {"width":"100%"},
                        optionFilterProp: "label",
                        onChange: _ctx.atualizarSelecaoEmpresas
                      }, null, 8, ["value", "options", "onChange"])
                    ])
                  ], 512), [
                    [_vShow, _ctx.telaBase.apresentarEmpresas]
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_a_form_item, {
                        label: "Estrutura de DRE Gerencial",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_estrutura_d_r_e, {
                            empresas: [_ctx.state.codigoEmpresa],
                            "codigo-selecionado": _ctx.state.codigoEstrutura,
                            "onUpdate:codigoSelecionado": [
                              _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.codigoEstrutura) = $event)),
                              _ctx.obterEstrutura
                            ]
                          }, null, 8, ["empresas", "codigo-selecionado", "onUpdate:codigoSelecionado"])
                        ]),
                        _: 1
                      })
                    ]),
                    (_ctx.state.codigoEstrutura === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createVNode(_component_a_form_item, {
                            label: " ",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: "ant-btn ant-btn-secondary ss-botao-crud",
                                title: "Nova estrutura",
                                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.incluirEstrutura && _ctx.incluirEstrutura(...args)))
                              }, [
                                _createVNode(_component_icone, {
                                  class: "ss-icone-crud",
                                  nome: "novo"
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.state.codigoEstrutura > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createVNode(_component_a_form_item, {
                            label: " ",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: "ant-btn ant-btn-secondary ss-botao-crud",
                                title: "Editar estrutura",
                                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.editarEstrutura && _ctx.editarEstrutura(...args)))
                              }, [
                                _createVNode(_component_icone, {
                                  class: "ss-icone-crud",
                                  nome: "editar"
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.state.codigoEstrutura > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_component_a_form_item, {
                            label: " ",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: "ant-btn ant-btn-secondary ss-botao-crud",
                                title: "Excluir estrutura",
                                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.excluirEstrutura && _ctx.excluirEstrutura(...args)))
                              }, [
                                _createVNode(_component_icone, {
                                  class: "ss-icone-crud",
                                  nome: "excluir"
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.state.codigoEstrutura > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createVNode(_component_a_form_item, {
                            label: " ",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: "ant-btn ant-btn-secondary ss-botao-crud",
                                title: "Salvar estrutura",
                                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.editarEstrutura && _ctx.editarEstrutura(...args)))
                              }, [
                                _createVNode(_component_icone, {
                                  class: "ss-icone-crud",
                                  nome: "salvar"
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_a_form_item, {
                        label: "Tipo de Período",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_sazonalidade, {
                            "apenas-principais": true,
                            valor: _ctx.state.tipoPeriodo,
                            "onUpdate:valor": [
                              _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.tipoPeriodo) = $event)),
                              _ctx.atualizarPeriodos
                            ]
                          }, null, 8, ["valor", "onUpdate:valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    (_ctx.state.tipoPeriodo !== _ctx.ESazonalidade.anual)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createVNode(_component_a_form_item, {
                            label: "Ano",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                class: "ant-input",
                                type: "number",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.ano) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.ano]
                              ])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_a_form_item, {
                        label: "Período",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_generico, {
                            itens: _ctx.state.periodos,
                            varios: true,
                            "valores-selecionados": _ctx.state.periodosSelecionados,
                            "onUpdate:valoresSelecionados": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.periodosSelecionados) = $event))
                          }, null, 8, ["itens", "valores-selecionados"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_selecionar_conta, {
                        title: "Contas",
                        varios: true,
                        empresas: [_ctx.state.codigoEmpresa],
                        codigosSelecionados: _ctx.state.contas,
                        "onUpdate:codigosSelecionados": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.contas) = $event))
                      }, null, 8, ["empresas", "codigosSelecionados"])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_a_form_item, {
                        label: "Centros de Custo",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_centro_custo, {
                            varios: true,
                            empresas: [_ctx.state.codigoEmpresa],
                            codigosSelecionados: _ctx.state.centrosCusto,
                            "onUpdate:codigosSelecionados": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.centrosCusto) = $event))
                          }, null, 8, ["empresas", "codigosSelecionados"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                (_ctx.UtilitarioGeral.validaLista(_ctx.state.estrutura.grupos) && _ctx.UtilitarioGeral.objetoValido(_ctx.state.estrutura.grupos[0].resultado))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_29,
                      _createElementVNode("div", _hoisted_30, [
                        (_ctx.state.paginaAtual !== 0 && !_ctx.telaBase.carregando)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.obterPaginaAnterior && _ctx.obterPaginaAnterior(...args)))
                            }, [
                              _createVNode(_component_icone, { nome: "navegacao-anterior" })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.estrutura.grupos[0].resultado.periodos, (periodo, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "ant-col ss-coluna-periodo",
                          key: index
                        }, _toDisplayString(_ctx.obterDescricaoPeriodo(periodo)), 1))
                      }), 128)),
                      _createElementVNode("div", _hoisted_31, [
                        (_ctx.state.paginaAtual !== _ctx.state.ultimaPagina && !_ctx.telaBase.carregando)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.obterProximaPagina && _ctx.obterProximaPagina(...args)))
                            }, [
                              _createVNode(_component_icone, { nome: "navegacao-proximo" })
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_a_spin, {
                spinning: _ctx.telaBase.carregando
              }, {
                default: _withCtx(() => [
                  (_ctx.state.codigoEstrutura === 0 || _ctx.state.codigoEstrutura === undefined)
                    ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                        key: 0,
                        mensagem: "Nenhuma estrutura selecionada"
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_draggable, {
                          modelValue: _ctx.state.estrutura.grupos,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.estrutura.grupos) = $event)),
                          "item-key": "codigo",
                          handle: ".ss-mover",
                          onSort: _ctx.ordemGruposAlterada
                        }, {
                          item: _withCtx(({ element, index }) => [
                            (_openBlock(), _createBlock(_component_grupo_resultado_d_r_e, {
                              class: "ss-mover",
                              key: element.codigo,
                              "colunas-grande": _ctx.state.colunasGrade,
                              grupo: _ctx.state.estrutura.grupos[index],
                              onEditarGrupo: _ctx.editarGrupo,
                              tipoPeriodo: _ctx.state.tipoPeriodo
                            }, null, 8, ["colunas-grande", "grupo", "onEditarGrupo", "tipoPeriodo"]))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onSort"]),
                        _createElementVNode("button", {
                          class: "ant-btn ant-btn-secondary",
                          style: {"width":"100%","font-size":"32px","height":"50px"},
                          onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.incluirGrupo && _ctx.incluirGrupo(...args)))
                        }, [
                          _createVNode(_component_icone, { nome: "novo" })
                        ])
                      ], 64))
                ]),
                _: 1
              }, 8, ["spinning"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_estrutura_d_r_e_modal, {
      visivel: _ctx.state.exibirEstrutura,
      "onUpdate:visivel": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.exibirEstrutura) = $event)),
      operacao: _ctx.state.operacaoLancamento,
      onRegistroAtualizado: _ctx.estruturaAtualizada
    }, null, 8, ["visivel", "operacao", "onRegistroAtualizado"]),
    _createVNode(_component_grupo_estrutura_d_r_e_modal, {
      estrutura: _ctx.state.codigoEstrutura,
      visivel: _ctx.state.exibirGrupo,
      "onUpdate:visivel": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.exibirGrupo) = $event)),
      operacao: _ctx.state.operacaoLancamento,
      onSincronizarRegistro: _ctx.obterGrupos
    }, null, 8, ["estrutura", "visivel", "operacao", "onSincronizarRegistro"]),
    _createVNode(_component_preview_pdf, {
      arquivos: _ctx.state.arquivosPdf
    }, null, 8, ["arquivos"])
  ], 64))
}